import { format, isToday, isYesterday } from "date-fns";
import { enGB, pl } from "date-fns/locale";
import type { TFunction } from "i18next";
import { isLekEn } from "src/helpers/services";

import type { ChatbotConversation, ChatbotConversationGroup } from "./types";

export function formatConversationTime(createdAt: string): string {
	return format(new Date(createdAt), "HH:mm");
}

export function groupConversationsByDate(
	conversations: ChatbotConversation[],
	t: TFunction,
): ChatbotConversationGroup[] {
	const groups = new Map<string, ChatbotConversation[]>();

	for (const conversation of conversations) {
		const date = new Date(conversation.createdAt);
		const label = isToday(date)
			? t("globalChatbot.history.today", "Dzisiaj")
			: isYesterday(date)
				? t("globalChatbot.history.yesterday", "Wczoraj")
				: format(date, "d MMMM", { locale: isLekEn() ? enGB : pl });

		groups.set(label, [...(groups.get(label) ?? []), conversation]);
	}

	return [...groups.entries()].map(([label, items]) => ({ label, items }));
}
